import {FORM, CHANNELS} from './endpoint'
import {
  GET_FEEDBACK_FORM,
  EDIT_FEEDBACK_FORM,
  EDIT_FORM_WIDGET,
  GET_WIDGET,
  EDIT_WIDGET,
  UPDATE_WIDGET_LOGO,
  GET_TWITTER_CODE,
  GET_CHANNELS_ALL,
  GET_CHANNEL,
  EDIT_STATUS_FORM,
  EDIT_CHANNEL,
  DELETE_CHANNEL,
  ADD_WHATSAPP_CHANNEL,
  CREATE_FEEDBACK_FORM,
  DELETE_FEEDBACK_FORM,
  SINGLE_FEEDBACK_FORM,
} from './types'
import {apiAction} from './api'

export function getFeedbackForm() {
  return apiAction({
    url: `${FORM}/forms?type=feedback`,
    method: 'GET',
    label: GET_FEEDBACK_FORM,
  })
}

export function editFeedbackForm(id, data) {
  return apiAction({
    url: `${FORM}/forms/${id}`,
    method: 'PUT',
    label: EDIT_FEEDBACK_FORM,
    data,
    showToast: true,
    successMessage: 'Contact Form Updated',
  })
}
export function createFeedbackForm(data) {
  return apiAction({
    url: `${FORM}/forms`,
    method: 'POST',
    label: CREATE_FEEDBACK_FORM,
    data,
    showToast: true,
    successMessage: 'Contact Form Created',
  })
}
export function deleteFeedbackForm(id) {
  return apiAction({
    url: `${FORM}/forms/${id}`,
    method: 'DELETE',
    label: DELETE_FEEDBACK_FORM,
    showToast: true,
    successMessage: 'Contact Form Deleted',
  })
}
export function getSingleFeedbackForm(id) {
  return apiAction({
    url: `${FORM}/forms/${id}`,
    method: 'GET',
    label: SINGLE_FEEDBACK_FORM,
  })
}

export function editFormStatus(data) {
  return apiAction({
    url: `${FORM}/forms/status`,
    method: 'PUT',
    label: EDIT_STATUS_FORM,
    data,
    showToast: true,
    successMessage: 'Status Updated',
  })
}

/// //---------> Widget

export function getWidget() {
  return apiAction({
    url: `${FORM}/widget`,
    method: 'GET',
    label: GET_WIDGET,
  })
}

export function editWidget(data) {
  return apiAction({
    url: `${FORM}/widget`,
    method: 'PUT',
    label: EDIT_WIDGET,
    data,
    showToast: true,
    successMessage: 'Settings Updated',
  })
}

export function editFormWidget(id, data) {
  return apiAction({
    url: `${FORM}/forms/${id}`,
    method: 'PUT',
    label: EDIT_FORM_WIDGET,
    data,
    showToast: true,
    // successMessage: "Widget Form Updated",
  })
}

export function updateWidgetLogo(data, id) {
  return apiAction({
    url: `${FORM}/forms/logo/${id}`,
    method: 'POST',
    label: UPDATE_WIDGET_LOGO,
    data,
    contentType: 'multipart/form-data',
    showToast: true,
    successMessage: 'Logo Updated',
  })
}

export function deleteWidgetLogo(id) {
  return apiAction({
    url: `${FORM}/forms/logo/${id}`,
    method: 'DELETE',
    label: 'DELETE_WIDGET_LOGO',
    showToast: true,
    successMessage: 'Logo Deleted',
  })
}

export function getSocialCode() {
  return apiAction({
    url: `${CHANNELS}/code`,
    method: 'GET',
    label: GET_TWITTER_CODE,
  })
}

export function getChannels(par) {
  const params = `?type=${par.type}`
  return apiAction({
    url: `${CHANNELS}${params}`,
    method: 'GET',
    label: GET_CHANNELS_ALL,
  })
}

export function getChannel(id) {
  return apiAction({
    url: `${CHANNELS}/${id}`,
    method: 'GET',
    label: GET_CHANNEL,
  })
}

export function editChannel(id, data) {
  return apiAction({
    url: `${CHANNELS}/${id}`,
    method: 'PUT',
    label: EDIT_CHANNEL,
    data,
    showToast: true,
    successMessage: 'Channel Updated',
  })
}

export function deleteChannel(id, data) {
  return apiAction({
    url: `${CHANNELS}/${id}`,
    method: 'DELETE',
    label: DELETE_CHANNEL,
    data,
    showToast: true,
    successMessage: 'Channel Deleted',
  })
}
// WhatsApp Channel

export function addWhatsAppChannel(data) {
  return apiAction({
    url: `${CHANNELS}/addWhatsApp`,
    method: 'POST',
    label: ADD_WHATSAPP_CHANNEL,
    data,
    tokenIdentity: 'chat',
    showToast: true,
    successMessage: 'Channel Added Successfully',
  })
}
